import PropTypes from "prop-types";

export const CountsCallsTooltip = ({ talked = false }) => (
  <>
    <div>Counts calls {talked ? "with an outcome of 'Talked'" : ""} to leads with intent of:</div>
    <ul className="tw-m-0 tw-p-0 tw-pl-[24px]">
      <li>Buyer</li>
      <li>Seller</li>
      <li>Buyer/Seller</li>
      <li>N/A</li>
    </ul>
  </>
);

CountsCallsTooltip.propTypes = {
  talked: PropTypes.bool,
};

export const SetHeldTooltip = () => (
  <>
    <div>Only appointment types which directly drive production are counted towards Set & Held goals:</div>
    <ul className="tw-m-0 tw-p-0 tw-pl-[24px]">
      <li>Buyer Consultation</li>
      <li>Listing Consultation</li>
      <li>Buyer/Listing Consultation</li>
    </ul>
  </>
);

export const signedTooltip =
  'Signing appointments completed with an outcome of "Signed - Buyer Agreement", "Signed - Listing Agreement", or "Signed - Both Buyer/Listing"';

export const pendedTooltip =
  "Transactions with a Mutual Acceptance Date within the selected timeframe. The Transaction Index view displays only the transactions that are currently pending.";
